import React from "react";
import SearchBar from "./SearchBar";
import List_items from "./ListItems";
import CustomCategory from "./CustomCategory";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch } from "react-icons/md";
import Button from "react-bootstrap/Button";

import { SaveAddCustom } from "../../API/MarketPlaceSetUp/SaveAddCustom";
import { AddCustom } from "./../../API/MarketPlaceSetUp/AddCustom";
import swal from "sweetalert";
import axios from "axios";
import { UnselectAddCategoryApi } from "../../API/MarketPlaceSetUp/UnselectAddCategory";
import NoDataText from "../../NoDataText";
import SearchBarResults from "../../Search/SearchBarResults";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../Utils/LocalStorage";

const ModalPopUp = (props) => {
  const {
    setShow,
    show,
    loading,
    setTableRows,
    setglobalTableRows,
    setTotalPageCount,
    setLimit,
    setLoading,
    setListDataAdd,
    listDataAdd,
    setGloballistDataListDataAdd,
    globallistDataAdd,
    scrollToBottom,
  } = props;

  // search
  const [search, setSearch] = useState("");

  // checkbox
  const [isCheck, setIsCheck] = useState([]);

  // toggle
  const [addShow, setaddShow] = useState(false);

  // add-custom
  const [addCustomData, setaddCustomData] = useState("");
  const [addCustomDataErr, setaddCustomDataErr] = useState("");

  const [addCustomDataArr, setaddCustomDataArr] = useState([]);
  const [isDisable, setisDisable] = useState(false);

  // search
  useEffect(() => {
    handleSearch();
  }, [search]);

  const handleSearch = () => {
    if (search.length === 0) {
      setListDataAdd(globallistDataAdd);
      // setShowTable(false)
    } else {
      const searchWords = search.toLowerCase().split(" ");
      const filteredData = listDataAdd.filter((data) => {
        const catNameLowerCase = data.cat_name.toLowerCase();
        return searchWords.every((word) => catNameLowerCase.includes(word));
      });

      if (filteredData.length === 0) {
        setListDataAdd([]);
      } else {
        setListDataAdd(filteredData);
      }
    }
  };

  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };
  // checkbox - tr

  const Auth_Token = getToken();

  useEffect(() => {
    const getOthersID = listDataAdd.filter((i, k) => i.status == true);
    const getOthersId = getOthersID.map((i, k) => i.cat_id);
    console.log(getOthersID, "getOthersID", getOthersId);
    setIsCheck(getOthersId);
  }, [listDataAdd]);

  const handleClick = async (e, key) => {
    const { checked } = e.target;
    if (listDataAdd[key].status == true) {
      setListDataAdd((value) => {
        const newArr = value.slice();
        newArr[key].status = false;
        UnCheckApi(listDataAdd[key].cat_id);
        return newArr;
      });
    } else {
      setListDataAdd((value) => {
        const newArr = value.slice();
        newArr[key].status = true;
        // console.log(newArr, "newArr");
        return newArr;
      });
    }
    setIsCheck([...isCheck, listDataAdd[key].cat_id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== listDataAdd[key].cat_id));
    }
  };

  // call api for unselect
  const UnCheckApi = (catId) => {
    const cityId = localStorage.getItem("cityId");
    axios({
      url: process.env.REACT_APP_COMMON_URL + "vms/mms/selectunselectcategory",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Token: Auth_Token,
      },
      data: {
        mms_city_id: parseInt(cityId),
        cat_id: parseInt(catId),
      },
    })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 429) {
          swal({
            title: response.data.message,
            icon: "warning",
            buttons: "Ok",
          });
          setLoading(true);
          scrollToBottom();
        } else if (response.data.success == false) {
          swal({
            title: response.data.message,
            icon: "warning",
            buttons: "Ok",
          });
          handleclose();
          scrollToBottom();
        }
      })
      .catch((err) => {
        setLoading(false);
        swal({
          // title: "Error!",
          title: `${err.data.message}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
      });
  };

  //  toggle
  const handleAddCustomToggle = () => {
    setaddShow(true);
    setaddCustomDataErr("");
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (addCustomDataArr.length >= 4) {
      setisDisable(true);
    }
  }, [addCustomDataArr]);

  const hanldeAddingCustom = async () => {
    if (addCustomData.length == 0) {
      setaddCustomDataErr("*Please enter category name!");
    }
    if (addCustomData.length != 0) {
      // AddCustom
      const cityId = localStorage.getItem("cityId");
      const data = {
        mms_city_id: parseInt(cityId),
        custom_cat_name: addCustomData,
      };
      const Response = await AddCustom(data, () => {
        navigate("/");
      });
      // console.log(Response,"Response")
      if (Response.success === true) {
        const r = {
          cat_id: Response.custom_id,
          cat_name: Response.custom_cat_name,
          status: true,
        };
        setListDataAdd([...listDataAdd, r]);
        setaddCustomData("");
        setaddCustomDataArr([...addCustomDataArr, addCustomData]);
      } else if (Response.staus === 429) {
        setLoading(true);
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "OK",
          dangerMode: false,
        });
      } else {
        swal({
          // title: "Error!",
          title: `${Response.message}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        swal.stopLoading();
        swal.close();
      }
    }
  };

  const handleDeleteAddCustomData = (e, key) => {
    const res = addCustomDataArr.filter((elem, k) => k != key);
    setaddCustomDataArr(res);
  };
  const handleclose = () => {
    setShow(false);
    setIsCheck([]);
    setaddCustomDataArr([]);
    setaddCustomData("");
    setSearch("");
  };

  const handleSave = async () => {
    // const others = listDataAdd.filter((elem) => elem.status === true);
    // const getArr = others.map((i, k) => i.cat_id);
    //  console.log(getArr,"getArr",others)
    // const withOthers = [...isCheck, getArr];
    // isCheck.length == 0 ? getArr : withOthers.flat(),
    // console.log(withOthers)
    // console.log(withOthers.flat());

    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      category_ids: isCheck,
    };
    const Res = await SaveAddCustom(data, () => {
      navigate("/");
    });
    // console.log(Res, "Res");
    if (Res.success === false) {
      setLoading(false);
      swal({
        // title: "Error!",
        title: ` ${Res.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setShow(false);
    } else {
      setShow(false);
      swal({
        // title: "Success!",
        title: `${Res.message}`,
        icon: "success",
        buttons: "Ok",
      }).then((success) => {
        if (success) {
          window.location.reload(false);
        }
      });
      setTableRows(Res.categorylist.categories);
      setglobalTableRows(Res.categorylist.categories);
      setTotalPageCount(Res.categorylist.total_cat_row);
      setLimit(Res.categorylist.limit);
      setLoading(false);
    }
    // }
  };
  return (
    <div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup-modal"
      >
        {" "}
        {/* <Modal.Header closeButton ></Modal.Header>{" "} */}
        <Modal.Body className="text-center mb-5">
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "baseline",
              gap: "27px",
            }}
          >
            {/* <p style={{color:'#e66100',fontSize:17}}>You can select up to 5 categories</p> */}
            <InputGroup className="search-bar">
              <InputGroup.Text>
                <MdSearch />
              </InputGroup.Text>
              <Form.Control
                className="search_feild"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                onKeyPress={handleKeypress}
              />
              <Button variant="outline-secondary" onClick={handleSearch}>
                Search
              </Button>
            </InputGroup>
          </div>
          <SearchBarResults SearchValue={search} />
          {/* table */}
          <div className="main-list">
            {listDataAdd.length == 0 ? (
              <p class="noData">{NoDataText.ErrText}</p>
            ) : (
              <table>
                {listDataAdd.map((item, key) => {
                  return (
                    <>
                      <tr>
                        <td className="radio-colors">
                          <Form.Check
                            aria-label="option 1"
                            className="orange-checkbox"
                            style={{ marginRight: 10 }}
                            onChange={(e) => handleClick(e, key)}
                            checked={
                              item.status === true
                                ? true
                                : isCheck.includes(item.cat_id)
                            }
                            disabled={item.cat_name == "OTHERS" ? true : false}
                          />
                        </td>
                        <td
                          className="pop-up-head"
                          style={{
                            color:
                              item.custom_status == true ? "#e66100" : "black",
                          }}
                        >
                          {item.cat_name}
                        </td>
                      </tr>
                    </>
                  );
                })}
              </table>
            )}
          </div>

          {/* onclick-show */}
          {addShow ? (
            <div
              className="hidden-type-category-main"
              style={{ marginTop: 40 }}
            >
              <p>You can add up to 5 custom categories</p>
              <div className="hidden-type-category">
                <input
                  autoComplete="off"
                  placeholder="Type Category"
                  type="text"
                  value={addCustomData}
                  maxLength={100}
                  onChange={(e) => setaddCustomData(e.target.value)}
                ></input>

                <div className="text-center small-btns d-flex option_btn">
                  <button
                    type="button"
                    class="green-btn mt-3 btn btn-primary hidden-add"
                    id="cancel-btn"
                    onClick={() => {
                      setaddShow(false);
                      setaddCustomData("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="green-btn mt-3 btn btn-primary hidden-add"
                    style={{ color: "white" }}
                    id="add-btn"
                    onClick={hanldeAddingCustom}
                    disabled={isDisable ? true : false}
                  >
                    Add
                  </button>
                </div>
              </div>
              <p className="max-char">(Maximum characters allowed: 100)</p>
              {addCustomDataErr && (
                <p className="text-danger">{addCustomDataErr}</p>
              )}
            </div>
          ) : (
            <div className="custom-category">
              <button
                className="add-custom-category"
                onClick={handleAddCustomToggle}
              >
                + Add Custom Category
              </button>
            </div>
          )}

          {/* {addCustomDataArr.length != 0 && addShow == true   ? 
        <>
        {addCustomDataArr.map((i,k)=>{
          return(
            <div style={{display:'flex'}}>
            <button>{i}</button>
            <span onClick={(e)=>handleDeleteAddCustomData(e,k)}>x</span>
            
            </div>
          )
        })}
        </>:""} */}
          {/* options */}
          <div className="text-center small-btns d-flex option_btn cancel">
            <button
              type="button"
              class="discard_btn btn btn-primary"
              onClick={handleclose}
            >
              Cancel
            </button>
            <button
              type="submit"
              class="green-btn mt-3 btn btn-primary"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModalPopUp;
